import { mapState, mapGetters } from 'vuex';
import { getHoursDifferenceMixin } from '@/utils/mixins';

export default {
  name: 'dataLayerMixin',
  mixins: [getHoursDifferenceMixin],

  computed: {
    ...mapState({
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
      mdmPatientId: ({ mdm }) => mdm.data.id,
      mdmData: ({ mdm }) => mdm.data,
      admission: ({ currentAdmission }) => currentAdmission.data,
      selectedUnit: ({ brandUnit }) => brandUnit.data.selectedUnit,
      hourAdmissionWithoutScheduling: ({ global }) => global.hourAdmissionWithoutScheduling,
      manuallySelectedExams: ({ searchExams }) => searchExams.data.manuallySelectedExams,
      servicesChange: ({ global }) => global.servicesChange,
      buttonConfirmArrival: ({ global }) => global.buttonConfirmArrival,
      listCategoryExams: ({ global }) => global.listCategoryExams,
      healthInsuranceVariables: ({ healthInsurance }) =>
        healthInsurance.data.healthInsuranceVariables,
      userCheckinOrigin: ({ global }) => global.userCheckinOrigin,
    }),

    ...mapGetters({
      hasCompletedFlow: 'global/hasCompletedFlow',
      isScheduledAdmission: 'global/isScheduledAdmission',
      isVaccineFlow: 'global/isVaccineFlow',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isTrackingActiveInUnit: 'isTrackingActiveInUnit',
      getBrandUnitIdVariables: 'getBrandUnitIdVariables',
      selectedBrand: 'selectedBrand',
      enumUnitSelected: 'enumUnitSelected',
      admissionFlows: 'global/admissionFlows',
      getInsurancePlan: 'getInsurancePlan',
    }),
  },
  methods: {
    mostCommonPagesAnalytics({
      eventType = 'view',
      message = undefined,
      currentStep = undefined,
      admission = undefined,
      complementaryObject = undefined,
      entireObject = undefined,
      origin = undefined,
      error = undefined,
    }) {
      let date;
      let hour;

      if (this.admission.id) {
        date = this.isScheduledAdmission
          ? this.returnExamsDates()
          : new Date().toLocaleDateString('pt-BR');
        hour = this.returnAdmissionHour();
      }

      let paymentMethod;

      if (this.admission?.payments[0]?.details?.type === 'PRIVATE') {
        paymentMethod = this.admission.paymentMethod
          ? `Particular | ${this.admission.paymentMethod}`
          : 'Particular';
      }

      if (this.admission?.payments[0]?.details?.type === 'HEALTH_INSURANCE') {
        paymentMethod = 'Convenio';
      }

      let cip;

      if (this.admission.patient.cip) {
        cip = this.admission.patient.cip;
      } else if (
        this.mdmData?.references?.length &&
        this.mdmData.references[0].referenceType === 'CIP'
      ) {
        cip = this.mdmData.references[0].value;
      }
      let analyticsObj = {
        event: eventType,
        funnel: {
          name: 'fluxo_checkin',
          current_step: currentStep,
          origin: this.userCheckinOrigin || 'other',
        },
        user: {
          mdm_id: this.mdmPatientId || undefined,
          cip,
          birthdate: this.mdmData.birthDate
            ? new Date(this.mdmData.birthDate).toLocaleDateString('pt-BR')
            : undefined,
        },
        admission: {
          id: this.admission.id || undefined,
          schedule_type: this.isScheduledAdmission ? 'agendado' : 'nao-agendado',
          scheduled_date: date,
          scheduled_time: hour,
          exam_category: this.listCategoryExams || undefined,
          unit_id: this.getBrandUnitIdVariables.unitId,
          unit_name: this.enumUnitSelected?.name ? this.enumUnitSelected.name : undefined,
          brand_id: this.getBrandUnitIdVariables.brandId || undefined,
          brand_name: this.selectedBrand?.name || undefined,
          payment_method: paymentMethod,
        },
        health_insurance: {
          provider: this.healthInsuranceVariables?.nomeCliente || undefined,
          details: this.getInsurancePlan || undefined,
        },
        flags: {
          elegible_t2_zero:
            this.admissionFlows.skipServiceDeskFlow ||
            this.admissionFlows.skipServiceDeskHealthInsuranceFlow,
          elegible_t2_fast: this.admissionFlows.skipServiceDeskHealthInsuranceFlow,
          services_changed: this.servicesChange,
          button_confirm_arrival: this.buttonConfirmArrival,
        },
        checkin_done: {
          message: message,
        },
        error: {
          origin,
          message: error,
        },
      };

      if (complementaryObject) {
        analyticsObj = { ...analyticsObj, ...complementaryObject };
      }

      if (admission) {
        analyticsObj.admission = admission;
      }

      if (entireObject) {
        analyticsObj = entireObject;
      }

      // eslint-disable-next-line no-undef
      dataLayer.push(analyticsObj);
    },
    dataLayerReset() {
      // eslint-disable-next-line no-undef
      dataLayer.push({
        event: 'funnel_step',
        funnel: undefined,
        user: undefined,
        admission: undefined,
        health_insurance: undefined,
        flags: undefined,
        checkin_done: undefined,
      });
    },
  },
};
